import React ,{useState,useEffect} from 'react'


const useGeoLocation = (enabled = true) => {
  const [location,setLocation] = useState({
    loaded :false,
    coordinates :{lat : "" , lng :""}
  })
    
  const onSuccess = (location) => {
       setLocation({   
            loaded : true,
            coordinates :{
                lat : location.coords.latitude,
                lng : location.coords.longitude
            }
        })
  }

  const onError = (error) => {
    setLocation({
        loaded : true,
        error,
    })
}

  useEffect(()=>{
    if (!enabled) return undefined;

    if(!("geolocation" in navigator)){
        onError({
            message : "geoLocation not supported"
        })
        return undefined;

    }

    navigator.geolocation.getCurrentPosition(onSuccess ,onError)
  },[enabled])
  
    return location  
  
}

export default useGeoLocation
